import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Header from "../../components/Headers/Header";
import { Card, CardHeader, Container, Row,  Button, Modal,ModalHeader } from "reactstrap";
import { getAll } from "../../network/ApiAxios";
import EditUserFullModal from './EditUserFullModal'

import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

const UsersTable = () => {
  const history = useHistory();
  const [users, setUsers] = useState();
  const [reload, setReload] = useState('');
  const [modal, setModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState();

  const toggle = () => setModal(!modal);
  
  useEffect(() => { 
    const runAsync = async () => {
      const response = await getAll("userTable");
      const { data } = response;
      if (data.success) {
        birthToAge(data.users);
        submitDateFormat(data.users);
        stayDuration(data.users);
        setUsers(data.users);
      }
    };
    runAsync();
  }, [reload]);

  async function editUser(e) {
    var useID = e.data._id;
    history.push("/admin/edituserfull", useID);
  }

  const birthToAge = (users) => {
    if (users) {
      users.map((user) => {
        if (user.birthday === "0000-00-00") {
          // calculate age
          users.birthday = "Nannn";
        } else {
          var today = new Date();
          var birthDate = new Date(user.birthday);
          var agecalc = today.getFullYear() - birthDate.getFullYear();
          var m = today.getMonth() - birthDate.getMonth();
          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            agecalc--;
          }
          user.birthday = agecalc;
        }
        return users
      });
    }
  };

  const submitDateFormat = (users) => {
    if (users) {
      users.map((user) => {
        if (user.date === "0000-00-00" || !user.date) {
          // calculate age
          users.birthday = "Nannn";
        } else {
          user.date = new Date(user.date);
        }
        return users
      });
    }
  };

  const stayDuration = (users) => {
    if (users) {
      users.map((user) => {
        // format start date
        var sDate = new Date(user.sDate);
        user.sDate = sDate.toLocaleDateString('en-GB')
        //get weeks from start and end date
        var eDate = new Date(user.eDate);
        var diff = Math.abs(eDate - sDate);
        var toDays = diff / (1000 * 3600 * 24);
        var round = Math.round((toDays / 7) * 10) / 10;
        user.eDate = round + " Weeks";
        return users
      });
      
    }
  };

  const getRowStyle = (params) => {
    if (params.node.rowIndex % 2 === 0) {
      return { background: "aliceblue" };
    }
  };

  const dynamicCellStyle = (params) => {
    if (params.value === 0) {
      return { backgroundColor: "red" };
    } else {
      return { backgroundColor: "greenyellow" };
    }
  };
  const [gridApi, setGridApi] = useState(null);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  const jobFilter = (params) => {
    setUsers(users.filter((user)=>{
      return user.sDate.includes("2023")
    }))
    gridApi.setQuickFilter("jobapp");
  };
  const resetFilter = (params) => {
    setReload(true)
    gridApi.setQuickFilter("");
  };

  const editUserModal = (e)=>{
    setSelectedUser(e.data._id)
    toggle()
  }

  return (
    <>
      <Header />
      <Container>
        <Row>
          <div className="col">
            <Card className="shadow" style={{ width:"100%"}}>
              {/* 
              <CardHeader>
                <Button onClick={jobFilter}>Filter job applicants</Button>
                <Button onClick={resetFilter} className="float-right btn-danger" >Reset filter</Button>
              </CardHeader>
              */}
              <div className="ag-theme-alpine" style={{ height: 500, width:"100%"}}>
              
                <AgGridReact
                  rowData={users}
                  animateRows={true}
                  onRowDoubleClicked={editUser}
                  onRowClicked={editUserModal}
                  pagination={true}
                  paginationPageSize={20}
                  getRowStyle={getRowStyle}
                  onGridReady={onGridReady}
                  defaultColDef={{
                    flex: 1,
                    filter: true,
                    sortable: true,
                    floatingFilter: true,
                    columnHoverHighlight: true,
                    resizable: true,
                    suppressDragLeaveHidesColumns: false,
                  }}
                >
                  
                  <AgGridColumn field="name" minWidth="170" style={{textAlign:"center"}}></AgGridColumn>
                  <AgGridColumn field="email" minWidth="200"></AgGridColumn>
                  <AgGridColumn field="role" minWidth="100" quickFilterText></AgGridColumn>
                  <AgGridColumn field="position" minWidth="120"></AgGridColumn>
                  <AgGridColumn
                    field="exp"
                    headerName="Experience"
                    minWidth="100"
                  ></AgGridColumn>
                  <AgGridColumn
                    field="birthday"
                    headerName="Age"
                    filter="agNumberColumnFilter"
                    minWidth="100"
                  ></AgGridColumn>
                  <AgGridColumn
                    headerName="Phase"
                    field="nextfase"
                    cellStyle={dynamicCellStyle}
                    minWidth="100"
                  ></AgGridColumn>
                  <AgGridColumn
                    field="sDate"
                    headerName="Start Date"
                    minWidth="100"
                  ></AgGridColumn>
                  <AgGridColumn
                    field="eDate"
                    headerName="Duration"
                    minWidth="100"
                  ></AgGridColumn>
                  <AgGridColumn
                    field="referer"
                    headerName="Referer"
                    minWidth="100"
                  ></AgGridColumn>
                  <AgGridColumn
                    field="date"
                    headerName="Date"
                    minWidth="300"
                    filter= 'agDateColumnFilter'
                  ></AgGridColumn>
                </AgGridReact>
              </div>
            </Card>
          </div>
        </Row>
      <Modal isOpen={modal} toggle={toggle} style={{maxWidth:'75%'}} >
        <ModalHeader toggle={toggle} close={<button className="close" onClick={toggle} type="button"> &times;</button>} ></ModalHeader>
        <EditUserFullModal userID={selectedUser} />
      </Modal>
      </Container>
    </>
  );
};

export default UsersTable;
